"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Returns true if file type contains string `image`
function isImageType(file) {
  if (!file) return false;
  return file.type && file.type.includes('image');
}

var _default = isImageType;
exports["default"] = _default;